
import { defineComponent, inject } from 'vue';
import { TipoVariavelRepository } from '@/dominio/editor/questoes/comum/variavel/tipo-variavel/TipoVariavelRepository';
import { TipoVariavelID } from '@/dominio/editor/questoes/comum/variavel/tipo-variavel/TipoVariavelID';

export default defineComponent({
    name: 'TipoVariavelSelecao',
    setup() {
        const repository = inject<TipoVariavelRepository>(
            'tipoVariavelRepository',
        );
        if (!repository) {
            throw new Error(
                'Não injetada a dependência tipoVariavelRepository',
            );
        }
        const tiposVariaveis = repository.obterTodos();
        return {
            tiposVariaveis,
        };
    },
    props: {
        id: {
            type: TipoVariavelID,
            required: false,
        },
    },
    data() {
        return {
            selecionado: '',
            erro: '',
        };
    },
    watch: {
        selecionado(novaSelecao: string) {
            if (!novaSelecao) {
                return this.$emit('selecionou', null);
            } else {
                const tipoVariavel = this.tiposVariaveis.find(tipo => {
                    return tipo.getId().toString() === novaSelecao;
                });
                if (!tipoVariavel) {
                    this.erro = 'Erro ao selecionar o tipo de variável';
                    return this.$emit('selecionou', null);
                } else {
                    this.$emit('selecionou', tipoVariavel.getId());
                }
            }
        },
    },
    emits: ['selecionou'],
});
